import { BaseHttpRequest } from './BaseHttpRequest';
import { request as __request } from './request';
export class FetchHttpRequest extends BaseHttpRequest {
    constructor(config, interceptor) {
        super(config);
        Object.defineProperty(this, "interceptor", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.interceptor = interceptor;
    }
    /**
     * Request method
     * @param options The request options from the service
     * @returns CancelablePromise<T>
     * @throws ApiError
     */
    request(options) {
        return __request(this.config, options, this.interceptor);
    }
}
//# sourceMappingURL=FetchHttpRequest.js.map